import React from 'react'
import {Box, Text,HStack, Image,Link} from '@chakra-ui/react'

const Faq = () => {
  return (
    <Box w='100%' h={['100%','100%','100%','75vh']} gap='6' flexWrap='wrap' display='flex' justifyContent='center' alignItems='center' p={['2rem','1rem','1rem','4rem']}>

        <Box w={['100%','50%','50%','30%']} p='1rem' h='100%'>
            <Image src='/illustration gif.svg' alt='' />
            <Text mt='1rem' fontWeight='500' fontFamily='Duplicate Sans' fontSize={['1.35rem','1.5rem']} >Provide and Effective Support </Text>
            <Text  mt='1rem' mb='1rem' color='#445368' fontFamily='Work Sans' fontSize='.85rem' lineHeight='24px'>
            We offer a seamless biometric transaction 
method. You can withdraw cash and 
also make online payments directly 
with just your biometrics.
            </Text>
            <HStack>
                <Link _hover={{textDecoration:'none'}} fontWeight='500' fontSize={['14px','']} color='#246BFD'>
                Chat with us 
                </Link>
                <Image src='/arrow.png' alt='' />
            </HStack>
        </Box>

        <Box w={['100%','50%','50%','30%']} p='1rem' h='100%'>
            <Image src='/illustration (1).svg' alt='' />
            <Text mt='1rem' fontWeight='500'fontFamily='Duplicate Sans' fontSize={['1.34rem','1.5rem']} >FAQs </Text>
            <Text  mt='1rem' mb='1rem' fontFamily='Work Sans' color='#445368' fontSize='.85rem' lineHeight='24px'>
            We offer a seamless biometric transaction 
method. You can withdraw cash and 
also make online payments directly 
with just your biometrics.
            </Text>
            <HStack>
                <Link _hover={{textDecoration:'none'}} fontWeight='500' fontSize={['14px','']} color='#246BFD'>
                Read FAQs 
                </Link>
                <Image src='/arrow.png' alt='' />
            </HStack>
        </Box>

        <Box w={['100%','50%','50%','30%']} p='1rem' h='100%'>
            <Image src='/developer.svg' alt='' />
            <Text mt='1rem' fontWeight='500' fontSize={['1.35rem','1.5rem']} fontFamily='Duplicate Sans' >Developers community </Text>
            <Text  mt='1rem' mb='1rem' color='#445368' fontSize='.85rem' lineHeight='24px'>
            We offer a seamless biometric transaction 
method. You can withdraw cash and 
also make online payments directly 
with just your biometrics.
            </Text>
            <HStack>
                <Link _hover={{textDecoration:'none'}} fontWeight='500' fontSize={['14px','']} color='#246BFD'>
                Join community
                </Link>
                <Image src='/arrow.png' alt='' />
            </HStack>
        </Box>

    </Box>
  )
}

export default Faq